// extracted by mini-css-extract-plugin
export default {"event":"Detail_event__wPCIb","timer":"Detail_timer__PRDV2","text":"Detail_text__yBagc"};